//微信网页授权登录

import {enableAppSDK, getWXLogin} from "./wxmp";
import {Dialog} from "vant";
import {browser} from "../../js/browser";

const wxRetState = 'ie8dflfLfiwq'


class cBase{
    constructor() {
        this.isWXAuth = false //是否已经授权
        this.userId = '0'
    }
}
let baseInfo = new cBase()

function firstEnter(that){
    let wx_code = that.$route.query.code
    let wx_state = that.$route.query.state //为调用前的参数

    if((wx_state&&wx_state==wxRetState)
        &&(wx_code&&wx_code!='')){
        //这里是微信授权回调页面
        // this.$router.push({name: ''})
        // 跳转到登录页面，完成再回来
        // 跳转理由：防止其他页面触发到授权接口，重复登录

        //向APP接口-获取token
        getWXLogin({'code': wx_code}).then(res=>{
            if(res.token){
                baseInfo.isWXAuth = true
                baseInfo.userId = res.userInfo.userId
                enableAppSDK(res.token)
            }
        }).catch(err=>{
            // alert(JSON.stringify(err))
            //过期，重登
            if(err.code==10014){
                login()
            }else{
                that.$myDialog({
                    logo: 'fail',
                    text: '微信code登录失败！',
                    btnOK: "关闭",
                    callBack: (state) => { }
                });
            }
        })
    }else{
        // console.log('微信未授权')
        //未授权，触发微信用户授权
        login()

        //测试
        // baseInfo.isWXAuth = true
        // baseInfo.userId = '4486011'
        // let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjExNDM2MCwiaXNzIjoiaHR0cHM6Ly90b29kby5jb20uY24vcG9wdWxhcml6YXRpb24vYXBpL3Rvb2RvIiwiaWF0IjoxNjYwNTI2MDM3LCJleHAiOjE2NjA1MzY4MzcsIm5iZiI6MTY2MDUyNjAzNywianRpIjoiMm9ORnI0UHA3c3RBZjY3dCJ9.uwOFseftSLFBCyibxWTCRyT2El6RVL2dhNtvdQPScRw'        // //let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjE5NCwiaXNzIjoiaHR0cHM6Ly90ZGRldi50b29kby5jb20uY24vcG9wdWxhcml6YXRpb24vYXBpL3Rvb2RvL3Rkay93eG1wIiwiaWF0IjoxNjU4NDU2MTg3LCJleHAiOjE2NTg0NjY5ODcsIm5iZiI6MTY1ODQ1NjE4NywianRpIjoiMmdWdnJmMmF2cUNvNk50cCJ9.byw8OYy2inFZE8G2bcl_U9KllASnHwSe47fsuXOofoY'
        // enableAppSDK(token)
    }
}

function  login(){
    if(!browser.getIsWechat()){
        // Dialog.setDefaultOptions({
        //     confirmButtonText: '确定',
        //     confirmButtonColor: '#0e556e'
        // });
        // Dialog.alert({
        //     title: '温馨提示',
        //     message: '请用微信浏览器打开!',
        // }).then(() => {
        //
        // });
        return
    }
    //考虑到用户可能在回调页面刷新
    //要去掉微信参数
    let src = window.location.href
    let index = src.indexOf("?")
    let sub = ''
    if (index === -1) {
        sub = src
    }else{
        sub = src.substring(0,index)
    }
    // let sub = src.substring(0)
    //未授权，触发微信用户授权
    let gotoUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0436c2e9ea60fce2&redirect_uri='
    gotoUrl += sub
    gotoUrl += '&response_type=code&scope=snsapi_userinfo&state='
    gotoUrl += wxRetState  //自定义
    gotoUrl += '#wechat_redirect'

    // alert(sub)
    //跳到微信授权页
    window.location.href = gotoUrl
}

function check(that){
    if(baseInfo.isWXAuth == true){
        return true
    }else{
        //提示登录
        Dialog.setDefaultOptions({
            confirmButtonText: '去登录',
            confirmButtonColor: '#0e556e'
        });
        Dialog.alert({
            title: '温馨提示',
            message: '请先进行登录!',
        }).then(() => {
            // on close
            login()
        });
        return false
    }
}

function getUserId(){
    return baseInfo.userId
}

function isAuth(){
    return baseInfo.isWXAuth
}

export const wxAuth = {
    firstEnter,
    login,
    check,
    getUserId,
    isAuth
}
